(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  // Fallback for templates whose main image isn't marked eager server-side:
  // promote the first VISIBLE image in the first sections (images inside
  // display:none, e.g. the hero's desktop copy on mobile, are skipped).
  const firstSectionImage = Array.prototype.find.call(
    document.querySelectorAll('.main-content > .shopify-section img'),
    (img) => img.getClientRects().length > 0
  );
  if (firstSectionImage && !firstSectionImage.hasAttribute('data-eager-img')) {
    firstSectionImage.setAttribute('loading', 'eager');
    firstSectionImage.setAttribute('fetchpriority', 'high');
  }

  } catch(e) { console.error(e); }
})();
})();
